import { FC } from 'react';
import { defineMessages, useIntl } from 'dibs-react-intl';
import { Breadcrumbs } from 'dibs-elements/exports/Breadcrumbs';

const messages = defineMessages({
    home: {
        id: 'nft.pdp.breadcrumb.home',
        defaultMessage: 'Home',
    },
    collection: {
        id: 'nft.pdp.breadbrumb.home',
        defaultMessage: 'NFT',
    },
});

export const NftPdpBreadcrumbs: FC = () => {
    const intl = useIntl();
    return (
        <Breadcrumbs
            breadcrumbs={[
                { text: intl.formatMessage(messages.home), path: null, isLinkable: false },
                {
                    text: intl.formatMessage(messages.collection),
                    path: '/nft-collections/',
                    isLinkable: true,
                },
            ]}
            isLastItemActive
        />
    );
};
